import { render, staticRenderFns } from "./SentGiftsSummary.vue?vue&type=template&id=1e0acfda&scoped=true"
import script from "./SentGiftsSummary.vue?vue&type=script&lang=ts"
export * from "./SentGiftsSummary.vue?vue&type=script&lang=ts"
import style0 from "./SentGiftsSummary.vue?vue&type=style&index=0&id=1e0acfda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0acfda",
  null
  
)

export default component.exports